import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone, QrCode } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="py-24 bg-copper">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white leading-tight">
          Ready to start? Book your $49.99 estimate today.
        </h2>
        <p className="text-white/80 font-inter mt-6 text-lg max-w-2xl mx-auto">
          No spam. No selling your info. Just a response from our team about your actual project. (Deposit will be applied to invoice after booking)
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link to="/contact">
            <Button 
              data-testid="cta-estimate-btn"
              className="bg-white text-copper hover:bg-white/90 px-8 py-6 text-xs font-bold uppercase tracking-widest group"
            >
              Book My Estimate Now
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <Dialog>
            <DialogTrigger asChild>
              <Button 
                data-testid="cta-payment-btn"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-copper px-8 py-6 text-xs font-bold uppercase tracking-widest"
              >
                <QrCode className="mr-2 h-4 w-4" />
                Make a Payment
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md bg-white">
              <DialogHeader>
                <DialogTitle className="font-playfair text-navy text-2xl">Pay with Zelle</DialogTitle>
                <DialogDescription className="text-navy/60">
                  Scan the QR code below with your banking app to send payment
                </DialogDescription>
              </DialogHeader>
              <div className="flex flex-col items-center py-6">
                <div className="bg-white p-4 rounded-lg shadow-lg">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/0bmfs3a5_Zell.jpeg" 
                    alt="Zelle QR Code"
                    className="w-48 h-48 object-cover object-center"
                    style={{ objectPosition: '50% 35%' }}
                  />
                </div>
                <p className="mt-4 text-navy font-inter text-sm text-center font-medium">
                  C.A.B ENTERPRISES OF TEXAS
                </p>
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <p className="text-white/60 font-inter text-sm mt-6">
          Flexible payment plans available on qualifying projects
        </p>
      </div>
    </section>
  );
};

export default CTASection;
